import BlankLayout from "layout/BlankLayout";
import FeedbackForm from "./components/FeedbackForm";
import placeHolderImage from "images/placeholder-3.svg";
import { useActivity } from "context/useActivity";
import { useEffect } from "react";

const Feedback = () => {
  const { activityCtx } = useActivity();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!activityCtx) {
    return <p>No data</p>;
  }

  return (
    <BlankLayout>
      <>
        <div className="section">
          <div className="container">
            <div className="intro-wrap">
              <div className="text-block heading-jumbo">
                Please tell us a little more about your selection by answering
                the questions below:
              </div>
            </div>
          </div>
        </div>
        <div className="section-3 wf-section">
          <div className="container-6 w-container">
            <div
              id="w-node-_47594a64-f80d-1765-d6b8-7fd7ed3fd5a4-25067e2d"
              className="div-block"
            >
              <img
                src={
                  activityCtx?.selectedActivity?.image_url || placeHolderImage
                }
                loading="lazy"
                id="w-node-e322954b-3006-b242-9119-ca2946d62610-25067e2d"
                alt=""
              />
              <a
                href={
                  activityCtx?.selectedActivity?.Activity_URL ||
                  "https://www.howtosmile.org/resource/smile-000-000-004-087"
                }
                target="_blank"
                className="link"
                rel="noreferrer"
              >
                {activityCtx?.selectedActivity?.Activity_Name || "-"}
              </a>
              <div
                id="w-node-_2ac58f0c-0728-6aa9-fbd3-7e3218b1e729-25067e2d"
                className="text-block-3"
              >
                {activityCtx?.selectedActivity?.Activity_Desc}
              </div>
            </div>
          </div>
        </div>
        <FeedbackForm keywords={activityCtx?.interests || []} />
      </>
    </BlankLayout>
  );
};

export default Feedback;
